import router from '@/router/index';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { removeAuth } from '@/utils/auth';
import Promise from 'promise';
import qs from 'qs';

var showLoginMessageBox = false;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 创建axios实例

var service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  var flag = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/json') !== -1;
  if (!flag) {
    var mult = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') !== -1;
    if (mult) {
      config.data = config.data;
    } else {
      config.data = qs.stringify(config.data);
    }
  }
  console.log(config);
  return config;
}, function (error) {
  // Do something with request error
  Promise.reject(error);
});

// http response 拦截器
service.interceptors.response.use(function (response) {
  //当返回信息为未登录或者登录失效的时候重定向为登录页面
  if (response.status != '200' || response.data == '登录用户信息为空' || response.data == '你无此访问权限') {
    removeAuth();
    router.push({
      path: "/login"
    });
  } else {
    return response.data;
  }
}, function (error) {
  return Promise.reject(error);
});

export default service;